import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-bus-direction',
  templateUrl: './bus-direction.component.html',
  styleUrls: ['./bus-direction.component.scss'],
})
export class BusDirectionComponent {
  @Input() currDirection;
  @Output() changeDirection: EventEmitter<any> = new EventEmitter<any>();

  selectOptions = [
    {
      value: 'all',
      label: 'All',
    },
    {
      value: '1',
      label: 'Direction 1',
    },
    {
      value: '2',
      label: 'Direction 2',
    },
  ];

  selectionOnChange(event: MatSelectChange) {
    console.log('event', event);
    const { value } = event;
    this.changeDirection.emit(value);
  }
}
